import { useEffect } from 'react';
import { toast } from 'sonner';
import { WifiOff, CloudUpload } from 'lucide-react';
import { useOfflineQueue } from '@/stores/offline-queue';
import { api } from '@/lib/api-client';
import type { DiveLog } from '@/types/api';

export function OfflineBanner() {
  const isOnline = useOfflineQueue((s) => s.isOnline);
  const items    = useOfflineQueue((s) => s.items);
  const remove   = useOfflineQueue((s) => s.remove);

  useEffect(() => {
    if (!isOnline || items.length === 0) return;
    void (async () => {
      for (const item of items) {
        try {
          await api<DiveLog>('/api/v1/dive-logs', { method: 'POST', body: item.payload });
          remove(item.id);
        } catch {
          // Stop on first failure – we'll retry on the next online tick.
          return;
        }
      }
      toast.success('Offline gespeicherte Tauchgänge synchronisiert.');
    })();
  }, [isOnline, items, remove]);

  if (isOnline && items.length === 0) return null;

  return (
    <div className="sticky top-0 z-40 flex items-center gap-2 bg-coral-500 px-4 py-2 text-sm text-white shadow-md">
      {isOnline ? <CloudUpload className="h-4 w-4" /> : <WifiOff className="h-4 w-4" />}
      <span>
        {isOnline
          ? `${items.length} Tauchgang${items.length === 1 ? '' : 'gänge'} wird/werden synchronisiert …`
          : 'Du bist offline. Tauchgänge werden lokal gespeichert und später synchronisiert.'}
      </span>
    </div>
  );
}
